import Image from "next/image";
import NexumAPI from "@/components/icons/nexum-api";
import { BookOpen } from "lucide-react";
import Glaci from "@/components/icons/glaci";
import PowerOnPipelines from "@/components/icons/poweron-pipelines";
import { cn } from "@/lib/utils";

const logos: Record<string, string> = {
  "poweron-pro": "/images/products/poweron-pro.svg",
};

/** Decorative product mark; its adjacent title supplies the accessible name. */
export function DocsProductLogo({
  product,
  className,
}: {
  product: string;
  className?: string;
}) {
  const classes = cn("shrink-0 object-contain", className);
  if (product === "glaci") {
    return <Glaci className={cn(classes, "glaci-colored")} aria-hidden />;
  }
  if (product === "poweron-pipelines") {
    return <PowerOnPipelines colored className={classes} aria-hidden />;
  }
  if (product === "nexum") {
    return <NexumAPI colored className={classes} aria-hidden />;
  }
  const src = logos[product];
  if (!src) return <BookOpen className={classes} aria-hidden />;
  return <Image src={src} width={32} height={32} alt="" className={classes} />;
}
